module.exports = __webpack_public_path__ + "assets/img/HH_Parc Central EC_RGB_lr.583b100d.jpg";